module.exports = __webpack_public_path__ + "static/계란유제품-df899088e9d0358b2e306a906e12312f.jpg";